import React, { Component } from 'react';
import $ from 'jquery';
import { Panel,Table } from 'react-bootstrap';


/* 课文音频在线播放 */
class OnlinePlay extends Component {

  constructor(props) {
    super(props);
    this.state = {
      grades: [],
      grade: -1,
      units: [],
      unit: -1,
      audios: [],
    };
    this.gradeChange = this.gradeChange.bind(this);
    this.unitChange = this.unitChange.bind(this);
  }

  gradeChange(event) {
    var that = this;
    this.setState({
      grade:event.target.value,
      unit: -1,
      units: [],
    })
    const url = URL+'api/units/'+event.target.value+'/';
    $(function(){$.ajax({
      headers:{
        'Content-Type':'application/json',
      },
      url: url,
      type: "GET",
      dataType: "json",
      data: {},
      success: function(data){
        that.setState({units:data,})
      },
      error: function(xhr, status, error){
        console.log(error.Message);
        alert(error.Message);
      }
    })})
  }

  unitChange(event) {
    this.setState({
      unit:event.target.value,
    });
    var no = event.target.value;
    var that = this;
    const url = URL+'api/gettextaudio/?grade='+ that.state.grade + '&unit=unit' + no +'/';
    $(function(){$.ajax({
      headers:{
        'Content-Type':'application/json',
      },
      url: url,
      type: "GET",
      dataType: "json",
      data: {},
      success: function(data){
        that.setState({audios:data,});
        console.log(data);
      },
      error: function(xhr, status, error){
        console.log(error.Message);
      }
    })})
  }

  componentDidMount() {
    var that = this;
    $(function(){$.ajax({
      url: URL + 'api/grads/',
      headers: {},
      type: "GET",
      dataType: "json",
      success: function(data) {
        that.setState({grades:data,});
      },
      error: function(xhr, status, err) {
        console.log(err.Message);
        alert('Error:'+err.Message);
      } 
    })});
  }

  render() {
    const gradeOptions = this.state.grades.map((grade)=>
      <option key={grade.id} value={grade.id}>{grade.name}</option>
      );
    const unitsOptions = this.state.units.map((unit) =>
      <option key={unit.id} id={unit.id} value={unit.no}>{unit.name}</option>
      );
    const audios = this.state.audios.map((audio)=>
      <tr><td>{audio.name}</td><td><audio key={audio.name} controls src={URL+audio.path} type="audio/mpeg">浏览器不支持</audio></td></tr>
    );
    return(
      <Panel>
        <Panel.Heading>
            <select name="grade_select" onChange={this.gradeChange}>
            <option key={100} value='请选择年级'>请选择年级</option>
            { gradeOptions }
          </select>
        <select name="unit_select" onChange={this.unitChange}>
          <option id="-1" value="-1">请选择单元</option>
          {unitsOptions}
        </select>
        </Panel.Heading>
        <Panel.Body>
          <Table striped hover>
            <thead>
              <tr>
                <th>内容</th><th>操作</th>
              </tr>
            </thead>
            <tbody>
              {audios}
            </tbody>
          </Table>
        </Panel.Body>
      </Panel>
    )
  }
}


export default OnlinePlay;



// WEBPACK FOOTER //
// ./src/Online_Play.js